module.exports = __webpack_public_path__ + "static/media/2.d56542f0.jpg";